import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PlugImageProvider } from "../../context/PlugImageContext";
export const PlugImage = () => {
  return (
    <PlugImageProvider>
      <Overview />
    </PlugImageProvider>
  );
};

export const AddPlugImage = () => {
  return (
    <PlugImageProvider>
      
        <Add />
      
    </PlugImageProvider>
  );
};

export const EditPlugImage = () => {
  return (
    <PlugImageProvider>
      
        <Edit />
      
    </PlugImageProvider>
  );
};
